// ABOUTME: The date-range presets of CDateRangePicker (this week, this month, …) and their ranges
// ABOUTME: Kept apart from the component so CDateRangePicker.tsx exports only the component

export type DateRangePreset = "week" | "month" | "lastMonth" | "3months" | "year" | "ytd" | "lastYear"

export interface PresetConfig {
  key: DateRangePreset
  labelKey: string
  getRange: () => { from: Date; to: Date }
}

// Use noon (12:00) to avoid timezone issues when converting to UTC
const getStartOfYear = (date: Date): Date => new Date(date.getFullYear(), 0, 1, 12, 0, 0)

const getStartOfWeek = (date: Date): Date => {
  const d = new Date(date)
  const day = d.getDay()
  const diff = d.getDate() - day + (day === 0 ? -6 : 1)
  d.setDate(diff)
  // Use noon (12:00) to avoid timezone issues
  return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 12, 0, 0)
}

const getEndOfWeek = (date: Date): Date => {
  const start = getStartOfWeek(date)
  // Use noon (12:00) to avoid timezone issues
  return new Date(start.getFullYear(), start.getMonth(), start.getDate() + 6, 12, 0, 0)
}

// Use noon (12:00) to avoid timezone issues when converting to UTC
const getStartOfMonth = (date: Date): Date => new Date(date.getFullYear(), date.getMonth(), 1, 12, 0, 0)
const getEndOfMonth = (date: Date): Date => new Date(date.getFullYear(), date.getMonth() + 1, 0, 12, 0, 0)

export const DEFAULT_PRESETS: PresetConfig[] = [
  {
    key: "week",
    labelKey: "statistics.presets.week",
    getRange: () => ({ from: getStartOfWeek(new Date()), to: getEndOfWeek(new Date()) }),
  },
  {
    key: "month",
    labelKey: "statistics.presets.month",
    getRange: () => ({ from: getStartOfMonth(new Date()), to: getEndOfMonth(new Date()) }),
  },
  {
    key: "lastMonth",
    labelKey: "statistics.presets.lastMonth",
    getRange: () => {
      const now = new Date()
      const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1, 12, 0, 0)
      return { from: getStartOfMonth(lastMonth), to: getEndOfMonth(lastMonth) }
    },
  },
  {
    key: "3months",
    labelKey: "statistics.presets.3months",
    getRange: () => {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0)
      return { from: new Date(now.getFullYear(), now.getMonth() - 3, 1, 12, 0, 0), to: today }
    },
  },
  {
    key: "ytd",
    labelKey: "statistics.presets.ytd",
    getRange: () => {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0)
      return { from: getStartOfYear(new Date()), to: today }
    },
  },
  {
    key: "year",
    labelKey: "statistics.presets.year",
    getRange: () => {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0)
      return { from: new Date(now.getFullYear() - 1, now.getMonth(), now.getDate(), 12, 0, 0), to: today }
    },
  },
  {
    key: "lastYear",
    labelKey: "statistics.presets.lastYear",
    getRange: () => {
      const lastYear = new Date().getFullYear() - 1
      return { from: new Date(lastYear, 0, 1, 12, 0, 0), to: new Date(lastYear, 11, 31, 12, 0, 0) }
    },
  },
]
